import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { ElMessage } from 'element-plus';

/**
 * 呼叫新增使用者群組設定
 * @param {*} i18n
 */
export function callHelpUserGroupSettingsCreate(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.createBtn',
        popover: {
          title: i18n.$t('MemberManagement').userGroupSettings.create,
          description: i18n.$t('MemberManagement').userGroupSettings.createExplain,
          onNextClick: () => {
            if (store.state.member.userGroupSettingsFormVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.li-object',
        popover: {
          title: i18n.$t('MemberManagement').userGroupSettings.create,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
          <p>${i18n.$t('DriverTourHelp').notInput} "\\/[]!@#$%^&*()+</p>`,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫編輯使用者群組設定
 * @param {*} i18n
 */
export function callHelpUserGroupSettingsEdit(i18n, store) {
  const tempList = store.state.member.userGroupSettingsList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('MemberManagement').userGroupSettings.userDescription;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.listEditBtn',
        popover: {
          title: i18n.$t('MemberManagement').userGroupSettings.edit,
          description: message,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫使用者群組設定使用者
 * @param {*} i18n
 */
export function callHelpUserGroupSettingsUser(i18n, store) {
  const tempList = store.state.member.userGroupSettingsList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('MemberManagement').userGroupSettings.userDescription;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.members',
        popover: {
          title: i18n.$t('MemberManagement').userGroupSettings.user,
          description: message,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
          onNextClick: () => {
            if (store.state.member.userGroupSettingsMembersVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickTheButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.userTransfer',
        popover: {
          title: i18n.$t('MemberManagement').userGroupSettings.user,
          description: i18n.$t('MemberManagement').userGroupSettings.userExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫使用者群組設定權限
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpUserGroupSettingsPermission(i18n, store) {
  const tempList = store.state.member.userGroupSettingsList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('MemberManagement').userGroupSettings.permissionDescription;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#authorityUpdate',
        popover: {
          title: i18n.$t('MemberManagement').userGroupSettings.permission,
          description: message,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
          onNextClick: () => {
            if (store.state.member.userGroupSettingsPermissionVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickTheButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.permissionTab',
        popover: {
          title: i18n.$t('MemberManagement').userGroupSettings.permission,
          description: i18n.$t('MemberManagement').userGroupSettings.permissionExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫使用者群組設定禁用管制項目
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpUserGroupSettingsForbidden(i18n, store) {
  const tempList = store.state.member.userGroupSettingsList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('MemberManagement').userGroupSettings.forbiddenControllItemDescription;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.forbidden',
        popover: {
          title: i18n.$t('MemberManagement').userGroupSettings.forbiddenControllItem,
          description: message,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
          onNextClick: () => {
            if (store.state.member.userGroupSettingsForbiddenVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickTheButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.para-li',
        popover: {
          title: i18n.$t('MemberManagement').userGroupSettings.forbiddenControllItem,
          description: i18n.$t('MemberManagement').userGroupSettings.forbiddenControllItemExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫使用者群組設定其他
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpUserGroupSettingsOther(i18n, store) {
  const tempList = store.state.member.userGroupSettingsList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('MemberManagement').userGroupSettings.otherDescription;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.other',
        popover: {
          title: i18n.$t('MemberManagement').userGroupSettings.other,
          description: message,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
          onNextClick: () => {
            if (store.state.member.userGroupSettingsOtherVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickTheButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.mb-5',
        popover: {
          title: i18n.$t('MemberManagement').userGroupSettings.other,
          description: `
          <p>${i18n.$t('MemberManagement').userGroupSettings.otherExplain}</p>
          <p>${i18n.$t('MemberManagement').userGroupSettings.hiddenChart}</p>`,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫刪除使用者群組設定
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpDeleteUserGroupSettings(i18n, store) {
  const tempList = store.state.member.userGroupSettingsList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('MemberManagement').userGroupSettings.deleteExplain;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.listDeleteBtn',
        popover: {
          title: i18n.$t('MemberManagement').userGroupSettings.delete,
          description: message,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫篩選使用者群組設定
 * @param {*} i18n
 */
export function callHelpFilterUserGroupSettings(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#searchRow',
        popover: {
          title: i18n.$t('MemberManagement').userGroupSettings.filter,
          description: i18n.$t('MemberManagement').userGroupSettings.filterExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫新增使用者設定
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpCreateUserSettings(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.createBtn',
        popover: {
          title: i18n.$t('MemberManagement').userSettings.create,
          description: i18n.$t('MemberManagement').userSettings.createDescription,
          onNextClick: () => {
            if (store.state.member.userSettingsFormVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.li-object',
        popover: {
          title: i18n.$t('MemberManagement').userSettings.create,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>`,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫檢視使用者設定
 * @param {*} i18n
 */
export function callHelpViewUserSettings(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.viewBtn',
        popover: {
          title: i18n.$t('MemberManagement').userSettings.view,
          description: i18n.$t('MemberManagement').userSettings.viewExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫使用者設定群組
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpUserSettingsGroup(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.groupBtn',
        popover: {
          title: i18n.$t('MemberManagement').userSettings.group,
          description: i18n.$t('MemberManagement').userSettings.groupDescription,
          onNextClick: () => {
            if (store.state.member.userSettingsGroupVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickTheButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.role-wrap',
        popover: {
          title: i18n.$t('MemberManagement').userSettings.group,
          description: i18n.$t('MemberManagement').userSettings.groupExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫使用者設定許可權
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpUserSettingsPermission(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#authorityUpdate',
        popover: {
          title: i18n.$t('MemberManagement').userSettings.permission,
          description: i18n.$t('MemberManagement').userSettings.permissionDescription,
          onNextClick: () => {
            if (store.state.member.userSettingsPermissionVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickTheButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.createaccess-group',
        popover: {
          title: i18n.$t('MemberManagement').userSettings.permission,
          description: i18n.$t('MemberManagement').userSettings.permissionExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫使用者禁用管制項目
 * @param {*} i18n
 */
export function callHelpUserSettingsForbidden(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.forbidden',
        popover: {
          title: i18n.$t('MemberManagement').userSettings.forbiddenControllItem,
          description: i18n.$t('MemberManagement').userSettings.forbiddenControllItemDescription,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫使用者其他功能
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpUserSettingsOtherFunction(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.other',
        popover: {
          title: i18n.$t('MemberManagement').userSettings.other,
          description: i18n.$t('MemberManagement').userSettings.otherDescription,
          onNextClick: () => {
            if (store.state.member.userSettingsOtherFunctionVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickTheButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.mb-5',
        popover: {
          title: i18n.$t('MemberManagement').userSettings.other,
          description: i18n.$t('MemberManagement').userSettings.otherExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫刪除使用者設定
 * @param {*} i18n
 */
export function callHelpDeleteUserSettings(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.listDeleteBtn',
        popover: {
          title: i18n.$t('MemberManagement').userSettings.delete,
          description: i18n.$t('MemberManagement').userSettings.deleteDescription,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫篩選使用者設定
 * @param {*} i18n
 */
export function callHelpFilterUserSettings(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#searchRow',
        popover: {
          title: i18n.$t('MemberManagement').userSettings.filter,
          description: i18n.$t('MemberManagement').userSettings.filterExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫通知設定新增
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpNotificationSettings(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.button-add',
        popover: {
          title: i18n.$t('MemberManagement').notificationSettings.name,
          description: i18n.$t('MemberManagement').notificationSettings.description,
          onNextClick: () => {
            if (store.state.member.notificationSettingsFormVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.inputName',
        popover: {
          title: i18n.$t('MemberManagement').notificationSettings.name,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
          <p>${i18n.$t('System_As_2').notInput} "\\/[]!@#$%^&*()+</p>`,
        },
      },

      {
        element: '.email',
        popover: {
          title: i18n.$t('MemberManagement').notificationSettings.EmailNotification,
          description: i18n.$t('MemberManagement').notificationSettings.EmailNotificationExplain,
        },
      },

      {
        element: '.weChat',
        popover: {
          title: i18n.$t('MemberManagement').notificationSettings.WeChatNotification,
          description: i18n.$t('MemberManagement').notificationSettings.WeChatNotificationExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫編輯通知設定
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpEditNotificationSettings(i18n, store) {
  const tempList = store.state.member.notificationSettingList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('MemberManagement').notificationSettings.editDescription;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.editBtn',
        popover: {
          title: i18n.$t('MemberManagement').notificationSettings.edit,
          description: message,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫通知設定群組
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpNotificationSettingsGroup(i18n, store) {
  const tempList = store.state.member.notificationSettingList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('MemberManagement').notificationSettings.groupDescription;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.groupBtn',
        popover: {
          title: i18n.$t('MemberManagement').notificationSettings.group,
          description: message,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
          onNextClick: () => {
            if (store.state.member.notificationSettingsGroupVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickTheButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.userTransfer',
        popover: {
          title: i18n.$t('MemberManagement').notificationSettings.group,
          description: i18n.$t('MemberManagement').notificationSettings.groupExpalin,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫通知設定人員管理
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpNotificationSettingsMember(i18n, store) {
  const tempList = store.state.member.notificationSettingList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('MemberManagement').notificationSettings.memberManagementDescription;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.memberBtn',
        popover: {
          title: i18n.$t('MemberManagement').notificationSettings.memberManagement,
          description: message,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
          onNextClick: () => {
            if (store.state.member.notificationSettingsMemberVisible) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickTheButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.userTransfer',
        popover: {
          title: i18n.$t('MemberManagement').notificationSettings.memberManagement,
          description: i18n.$t('MemberManagement').notificationSettings.memberManagementExpalin,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫刪除通知設定
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpDeleteNotificationSettings(i18n, store) {
  const tempList = store.state.member.notificationSettingList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('MemberManagement').notificationSettings.deleteDescription;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.deleteBtn',
        popover: {
          title: i18n.$t('MemberManagement').notificationSettings.delete,
          description: message,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫篩選通知設定
 * @param {*} i18n
 */
export function callHelpFilterNotificationSettings(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#searchRow',
        popover: {
          title: i18n.$t('MemberManagement').notificationSettings.filter,
          description: i18n.$t('MemberManagement').notificationSettings.filterExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}
